import React, { useState } from 'react';
import './ModernSidebar.css';

const ModernSidebar = ({ isOpen, onClose, currentView, onNavigate, userRole = 'customer' }) => {
  const [expandedSection, setExpandedSection] = useState(null);

  const menuItems = {
    customer: [
      {
        section: 'Dashboard',
        icon: '📊',
        items: [
          { label: 'Overview', id: 'dashboard', icon: '🏠' },
          { label: 'My Bookings', id: 'bookings', icon: '📅' },
          { label: 'Messages', id: 'messages', icon: '💬' },
        ],
      },
      {
        section: 'Business',
        icon: '🏢',
        items: [
          { label: 'Contacts', id: 'crm', icon: '👥' },
          { label: 'Campaigns', id: 'campaigns', icon: '📢' },
          { label: 'Analytics', id: 'analytics', icon: '📈' },
        ],
      },
      {
        section: 'Settings',
        icon: '⚙️',
        items: [
          { label: 'Profile', id: 'profile', icon: '👤' },
          { label: 'Preferences', id: 'preferences', icon: '🎨' },
          { label: 'Billing', id: 'billing', icon: '💳' },
        ],
      },
    ],
    staff: [
      {
        section: 'Operations',
        icon: '🔧',
        items: [
          { label: 'Dashboard', id: 'dashboard', icon: '🏠' },
          { label: 'Bookings', id: 'bookings', icon: '📅' },
          { label: 'Customers', id: 'crm', icon: '👥' },
          { label: 'Campaigns', id: 'campaigns', icon: '📢' },
        ],
      },
      {
        section: 'Communication',
        icon: '💬',
        items: [
          { label: 'SMS', id: 'sms', icon: '📱' },
          { label: 'Email', id: 'email', icon: '✉️' },
          { label: 'WhatsApp', id: 'whatsapp', icon: '💬' },
        ],
      },
      {
        section: 'Settings',
        icon: '⚙️',
        items: [
          { label: 'Business Profile', id: 'profile', icon: '🏢' },
          { label: 'Team', id: 'team', icon: '👥' },
          { label: 'Integrations', id: 'integrations', icon: '🔗' },
        ],
      },
    ],
    ceo: [
      {
        section: 'Dashboard',
        icon: '📊',
        items: [
          { label: 'Overview', id: 'dashboard', icon: '🏠' },
          { label: 'Analytics', id: 'analytics', icon: '📈' },
          { label: 'Financial', id: 'financial', icon: '💰' },
        ],
      },
      {
        section: 'Management',
        icon: '🎯',
        items: [
          { label: 'Bookings', id: 'bookings', icon: '📅' },
          { label: 'Customers', id: 'crm', icon: '👥' },
          { label: 'Team', id: 'team', icon: '👔' },
          { label: 'Campaigns', id: 'campaigns', icon: '📢' },
        ],
      },
      {
        section: 'System',
        icon: '⚙️',
        items: [
          { label: 'Settings', id: 'settings', icon: '⚙️' },
          { label: 'Users', id: 'users', icon: '👨‍💼' },
          { label: 'Audit Log', id: 'audit', icon: '📋' },
        ],
      },
    ],
  };

  const navItems = menuItems[userRole] || menuItems.customer;

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleItemClick = (itemId) => {
    onNavigate(itemId);
    if (window.innerWidth < 768) {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}

      {/* Sidebar */}
      <aside className={`modern-sidebar ${isOpen ? 'open' : ''}`}>
        {/* Header */}
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <span className="logo-icon">🌳</span>
            <span className="logo-text">Oakdesk</span>
          </div>
          <button className="sidebar-close" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {navItems.map((section) => (
            <div key={section.section} className="nav-section">
              <button
                className="nav-section-title"
                onClick={() => toggleSection(section.section)}
              >
                <span className="section-icon">{section.icon}</span>
                <span>{section.section}</span>
                <span className={`expand-icon ${expandedSection === section.section ? 'expanded' : ''}`}>
                  ▼
                </span>
              </button>

              <div
                className={`nav-items ${expandedSection === section.section ? 'expanded' : ''}`}
              >
                {section.items.map((item) => (
                  <button
                    key={item.id}
                    className={`nav-item ${currentView === item.id ? 'active' : ''}`}
                    onClick={() => handleItemClick(item.id)}
                  >
                    <span className="item-icon">{item.icon}</span>
                    <span className="item-label">{item.label}</span>
                    {currentView === item.id && <span className="active-indicator">●</span>}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div className="sidebar-footer">
          <button className="user-profile">
            <span className="avatar">👤</span>
            <div className="user-info">
              <div className="user-name">John Doe</div>
              <div className="user-role">{userRole}</div>
            </div>
          </button>
          <button className="logout-btn" title="Logout">
            🚪
          </button>
        </div>
      </aside>
    </>
  );
};

export default ModernSidebar;
